<div class="d-flex flex-column w-100">
  <input
    class="apm-input text-end {{ field.className }}"
    type="number"
    [ngClass]="{ 'certified--green': field.props.flags === 1, 'certified--light-green': field.props.flags === 3 }"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (keydown)="onKeyDown($event)"
  />
  <div class="d-block invalid-feedback" *ngIf="formControl.errors?.min">
    {{ 451598 | apmTranslate: [formControl.errors?.min.min] }}
  </div>
  <div class="d-block invalid-feedback" *ngIf="formControl.errors?.max">
    {{ 448588 | apmTranslate: [formControl.errors?.max.max] }}
  </div>
</div>
